// handlers.js

export const handleTimeZoneChange = (event, setTimeZone) => {
    setTimeZone(event.target.value);
};

export const handleGridModelChange = (event, index, gridModels, setGridModels) => {
  const newModels = [...gridModels];
  newModels[index] = event.target.value;
  setGridModels(newModels);
};

export const handleSelectChange = (e, type, varClass, setState) => {
    const value = e.target.value;
    if (type === "Model") {
        setState.setSelectedModel(value);
        setState.setCompareBool(value === "compare");
    }
    if (type === "Initialization") {
        setState.initFhourAdjust({
            selectedModel: setState.selectedModel,
            selectedInit: value,
            fhour: setState.fhour,
            setFhour: setState.setFhour,
            prevSelectedInitRef: setState.prevSelectedInitRef
        });
        setState.setSelectedInit(value);
    }
    if (type === "Variable") {
        setState.setSelectedVariable(value);
        if (varClass) {
            setState.setSelectedVarClass(varClass);
        }
    }
};
